const links = {
  salesmrkt: "https://salesmrkt.com",
  calendly: "https://calendly.com/cascadeclarity/30min",
  linkedin: "https://www.linkedin.com/company/cascadeclarity-ai/",
};

export default links;
